import { locations } from './locations';
import { contact } from './contact';
import { events } from './events';

export const contactPage = { locations, contact, events };
